

export enum KalturaInheritanceType {
    inherit=1,
	manual=2
}